import * as React from 'react'
import { FormattedMessage } from 'react-intl'

// $FlowIgnore TS import
import Date from '../components/Date'
import linkStyles from '../components/DetailsLink.css'
import DetailsLink from '../components/DetailsLink'
import PropertyWithTitle from '../components/PropertyWithTitle'
// @ts-ignore
import RawFormattedMessage from '../components/RawFormattedMessage'
import { StatusWithTitle } from '../components/Status'
import { getListItemProps } from '../docs'
import listStyles from '../list/List.css'
import { Document } from '../../types/Docs'
import { ListItemProps } from '../../types/List'

export function ExpiryDate (props: { value: boolean | string }) {
  let expirationDateValue: JSX.Element
  if (typeof props.value === 'boolean' || !props.value) {
    expirationDateValue = (
      <FormattedMessage
        id={
          props.value
            ? 'shared.expiry-date.required'
            : 'shared.expiry-date.not-required'
        }
      />
    )
  } else {
    expirationDateValue = (
      <Date isInline={true} customDateFormat='no-time' value={props.value} />
    )
  }

  return (
    <PropertyWithTitle isList title='shared.expiry-date-title'>
      {expirationDateValue}
    </PropertyWithTitle>
  )
}

export default function DocsListItem ({
  item,
  keyPrefix
}: ListItemProps<Document>) {
  const props = getListItemProps(item)
  return (
    <tr className={listStyles.tableRow}>
      <td scope='row' className={listStyles.itemTitle}>
        <PropertyWithTitle isList title='shared.name'>
          {props.name}
        </PropertyWithTitle>
      </td>
      <td className={listStyles.tableCell}>
        <ExpiryDate value={props.expiryDate} />
      </td>
      <td className={listStyles.tableCell}>
        {props.status && <StatusWithTitle isList status={props.status} />}
      </td>
      <td className={listStyles.tableCell}>
        {props.url && (
          <a href={props.url} className={linkStyles.inlined} target='_new'>
            <RawFormattedMessage id='shared.download' />
          </a>
        )}
        <DetailsLink
          labelKey='shared.upload.submit'
          section={keyPrefix}
          inlined={true}
          qs={{
            parent_id: props.parentResourceId,
            doc_id: props.id
          }}
        />
      </td>
    </tr>
  )
}
